module.exports = __webpack_public_path__ + "static/media/vineeth.592da830.jpg";